import {
  Component,
  input,
  output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { SelectItem } from '@openng/optimus-ui/api';
import { Select } from '@openng/optimus-ui/select';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-actions-dropdown',
  templateUrl: './actions-dropdown.component.html',
  styleUrls: ['./actions-dropdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [Select, FormsModule, TranslatePipe],
})
export class ActionsDropdownComponent {
  readonly availableActions = input.required<SelectItem<string>[]>();
  isDisabled: boolean = false;
  currentAction = null;

  readonly actionSelected = output<string>();

  clear() {
    this.currentAction = null;
  }
}
